import * as Yup from 'yup';
import { getUserShape } from 'validators/Common/baseUserValidator';

export class CreateMemberValidator {
  public get schema() {
    return Yup.object().shape({
      user: Yup.object()
        .required('Usuário é obrigatório')
        .shape({
          ...getUserShape(),
        }),
    });
  }
}